<template>
  <section class="bg-login-image relative flex flex-col gap-3 min-h-screen">
    <!-- Overlay oscuro -->
    <div class="absolute inset-0 bg-black/50"></div>

    <!-- Contenido -->
    <div
      class="relative flex flex-col w-full max-w-lg items-center lg:max-w-md xl:max-w-xl gap-6 px-6 py-8 sm:px-12 md:px-16 m-auto bg-white/80 rounded-lg shadow-lg dark:bg-gray-800">
      <img src="../../assets/logo.png" class="w-28" />

      <div class="w-full">
        <h1 class="text-xl md:text-2xl font-bold leading-tight tracking-tight text-gray-900 dark:text-white text-center">
          Ingresa con tu cuenta
        </h1>
        <form class="space-y-6" @submit.prevent="loginUsuario">
          <div>
            <label for="email"
              class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Tu correo</label>
            <input type="email" v-model="email" name="email" id="email"
              class="w-full p-3 text-sm border rounded-lg bg-gray-50 border-gray-300 text-gray-900 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder="servicio@clinico.com" required>
          </div>
          <div>
            <label for="password"
              class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Contraseña</label>
            <input type="password" v-model="password" name="password" id="password" placeholder="••••••••"
              class="w-full p-3 text-sm border rounded-lg bg-gray-50 border-gray-300 text-gray-900 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              required>
          </div>
          <div class="flex items-center justify-between">
            <div class="flex items-center">
              <input id="remember" type="checkbox"
                class="w-4 h-4 border border-gray-300 rounded bg-gray-50 focus:ring-2 focus:ring-primary-300 dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-primary-600 dark:ring-offset-gray-800">
              <label for="remember" class="ml-2 text-sm text-gray-500 dark:text-gray-300">Recuérdame</label>
            </div>
            <router-link to="/recuperar-cuenta" class="flex items-center p-2 hover:underline hover:text-green-700 text-green-700 group">   
              <span  class="">Olvide mi contraseña</span>
            </router-link>
          </div>
          <button type="submit" :disabled="isLoading"
            class="w-full flex items-center justify-center px-4 py-3 text-sm font-medium text-white bg-green-700 rounded-lg hover:bg-green-800 focus:ring-4 focus:ring-green-300 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800">
            <svg v-if="isLoading" class="w-5 h-5 animate-spin mr-3 text-white" xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 100 101" fill="none">
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="#E5E7EB" />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentColor" />
            </svg>
            <span v-if="isLoading">Cargando...</span>
            <span v-else>Ingresar</span>
          </button>
          <div v-if="errorMessage" class="text-red-600 text-sm text-center">
            {{ errorMessage }}
          </div>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import { getAuth, signInWithEmailAndPassword, onAuthStateChanged,setPersistence, browserLocalPersistence } from 'firebase/auth';
import { auth, db } from '../../firebase'; // Asegúrate de que las rutas están correctas
import { doc, getDoc } from 'firebase/firestore';

export default {
  name: 'LoginUsuario',
  data() {
    return {
      email: '',
      password: '',
      errorMessage: '',
      isLoading: false,
    };
  },
  created() {
    const auth = getAuth();

    onAuthStateChanged(auth, (user) => {
      if (user) {
        user.getIdToken()
          .then((idToken) => {
            localStorage.setItem('idToken', idToken);
          })
          .catch((error) => {
            console.error('Error al obtener el token:', error);
          });
      } else {
        this.$router.push('/login');
      }
    });
  },
  methods: {
    async loginUsuario() {
      this.isLoading = true;
      try {
        // Verifica que los campos email y password no estén vacíos
        if (!this.email || !this.password) {
          this.errorMessage = 'Debes ingresar un correo y una contraseña válidos.';
          return;
        }
        
        await setPersistence(auth, browserLocalPersistence);

// Iniciar sesión con credenciales de correo y contraseña
const userCredential = await signInWithEmailAndPassword(auth, this.email, this.password);
  //       setPersistence(auth, browserLocalPersistence)
  // .then(() => {
  //   // Realizar el inicio de sesión
  //   // return signInWithEmailAndPassword(auth, email, password);
  //     userCredential = signInWithEmailAndPassword(auth, this.email, this.password);
  // })
  // .catch((error) => {
  //   console.error("Error configurando la persistencia:", error);
  // });
        const user = userCredential.user; // Obtiene el UID del usuario autenticado

        // Verificar el rol del usuario en Firestore
        await this.verificarRolUsuario(user);

      } catch (error) {
        this.manejarErroresAuth(error);
      } finally {
        this.isLoading = false;
      }
    },

    // Función para manejar los errores de autenticación
    manejarErroresAuth(error) {
      if (error.code === 'auth/invalid-email') {
        this.errorMessage = 'El formato del correo electrónico no es válido.';
      } else if (error.code === 'auth/wrong-password') {
        this.errorMessage = 'Contraseña incorrecta.';
      } else if (error.code === 'auth/user-not-found') {
        this.errorMessage = 'No se encontró un usuario con ese correo.';
      } else {
        this.errorMessage = 'Error en el inicio de sesión. Verifica tus credenciales.';
      }
    },

    // Función para verificar el rol del usuario en Firestore
    async verificarRolUsuario(user) {
      try {
        let usuarioEncontrado = false;

        // Verificar en la colección de "pacientes"
        const pacienteDoc = await getDoc(doc(db, "pacientes", user.uid));
        if (pacienteDoc.exists()) {
          this.$router.push(`/paciente/${user.uid}`);
          return usuarioEncontrado = true;
        }

        // Verificar en la colección de "enfermeros" si no es paciente
        if (!usuarioEncontrado) {
          const enfermeroDoc = await getDoc(doc(db, "enfermeros", user.uid));
          if (enfermeroDoc.exists()) {
            this.$router.push('/enfermero/calendario');
            usuarioEncontrado = true;
          }
        }

        if (!usuarioEncontrado) {
  const userDoc = await getDoc(doc(db, "users", user.uid));
  if (userDoc.exists()) {
    const rol = userDoc.data().role;
    localStorage.setItem('role', rol); // Guarda el rol

    if (rol === 'admin') {
      this.$router.push('/admin/calendario');
    } else if (rol === 'supervisor') {
      this.$router.push('/pos');
    } else if (rol === 'enfermero' || rol === 'esteticista') {
      this.$router.push('/enfermero/calendario');
    } else {
      this.$router.push('/login');
    }

    usuarioEncontrado = true;
  }
}


        // Si no se encuentra en ninguna colección
        if (!usuarioEncontrado) {
          console.error('Usuario no encontrado en las colecciones de pacientes, enfermeros o admins');
          this.errorMessage = 'No se encontró el usuario en las colecciones adecuadas.';
          this.$router.push('/login');
        }

      } catch (error) {
        console.error('Error al verificar el rol del usuario:', error);
        this.errorMessage = 'Hubo un error al verificar el rol del usuario.';
      }
    }
  }
};
</script>

<style scoped>
.bg-login-image {
  background-image: url('/public/fondologin.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 100vh;
}
</style>
